import { mixpanel } from '@/mixpanel'
import { useNotificationChannel } from '@/modules/healthblocks/hooks/useNotificationChannel'
import { BadgeService } from '@/modules/shared/services/badgeService'
import { usePendingTaskCount } from '@/modules/task/hooks/usePendingTaskCount'

/**
 * Clears what this device keeps of the current profile: cached responses, the
 * push notification channel, the pending task count, the app badge and the
 * analytics identity. Shared by logging out and switching hospital.
 * Must run while the current hospital's session is still active, because
 * removing the push channel is an authenticated request.
 */
function useClearLocalSession() {
  const { deleteLocalNotificationChannel } = useNotificationChannel()
  const { resetPendingTaskCount } = usePendingTaskCount()

  return async function clearLocalSession() {
    // Clear axios-cache from localStorage
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('axios-cache:')) {
        localStorage.removeItem(key)
      }
    })

    try {
      // Remove notification channel
      await deleteLocalNotificationChannel()
    } catch (error) {
      console.error(error)
    }

    // Reset the pending task count
    resetPendingTaskCount()

    // Clear app badge
    try {
      await BadgeService.clearBadge()
    } catch (error) {
      console.error('Failed to clear badge during logout:', error)
    }

    // Reset Mixpanel identification
    mixpanel.reset()
  }
}

export { useClearLocalSession }
